import React from "react";
import { Button } from "semantic-ui-react";

interface FieldLabelWithButtonProps {
  label: string;
  buttonText: string;
  htmlFor?: string;
  required?: boolean;
  showButton?: boolean;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
}

export const FieldLabelWithButton: React.FC<FieldLabelWithButtonProps> = ({
  label,
  buttonText,
  htmlFor,
  required = false,
  showButton = true,
  disabled = false,
  onClick = () => {},
  className = "",
}) => {
  return (
    <label htmlFor={htmlFor} className={className}>
      <div className='tw-flex tw-items-center tw-justify-between'>
        <span>
          {label}
          {/* We have to make our own required asterisks because our label text is nested */}
          {required && <span style={{ color: "#DB2828", margin: "-0.2em 0em 0em 0.2em" }}>*</span>}
        </span>

        {showButton && (
          <Button
            className='tw-m-0 tw-bg-transparent tw-p-0 tw-text-left tw-text-blue'
            disabled={disabled}
            onClick={onClick}
            content={buttonText}
          />
        )}
      </div>
    </label>
  );
};
